import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home/home.component';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginDlgComponent } from './dialog/login-dlg/login-dlg.component';
import {MatDialogModule} from '@angular/material/dialog';
import { AdminComponent } from './admin/admin/admin.component';
import { AnimateDigitComponent } from './component/animate-digit/animate-digit.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginDlgComponent,
    AdminComponent,
    AnimateDigitComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents:[LoginDlgComponent, AnimateDigitComponent]
})
export class AppModule { }
